import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { domain } from "../variables/domain";
import { BehaviorSubject, Subject } from "rxjs";
import { AnimationController, ModalController } from "@ionic/angular";
import { SubscriptionExpiredComponent } from "../shared-module/components/subscription-expired/subscription-expired.component";
import { map } from "rxjs/operators";
import { UserLoginPage } from "../modules/login/user-login/user-login.page";
import { EncryptionService } from "./encryption.service";
import { AgentSignupComponent } from "../modules/login/agent-signup/agent-signup.component";
import { MatDialog } from "@angular/material/dialog";
import { DialogInfoDetailsComponent } from "../shared-module/components/dialog-info-details/dialog-info-details.component";

@Injectable({
  providedIn: "root",
})
export class SharedServices {
  private isLoggedIn = new Subject<any>();
  private cityChanged = new BehaviorSubject<any>(null);
  leave: any;
  constructor(
    private http: HttpClient,
    private modalCtrl: ModalController,
    private animationCtrl: AnimationController,
    private encryptionService: EncryptionService,
    private matDialog: MatDialog
  ) { }
amountValueText(amountValue:any): string {
  if (amountValue === null || amountValue === undefined || amountValue === '') {
    return '';
  }

  const value = Number(amountValue);

  if (Number.isNaN(value)) {
    return amountValue.toString();
  }

  if (value >= 1_00_00_000) { // 1 Crore
    return (value / 1_00_00_000).toFixed(value % 1_00_00_000 === 0 ? 0 : 1) + 'CR';
  }
  if (value >= 1_00_000) { // 1 Lakh
    return (value / 1_00_000).toFixed(value % 1_00_000 === 0 ? 0 : 1) + 'L';
  }
  if (value >= 1_000_000) {
    return (value / 1_000_000).toFixed(value % 1_000_000 === 0 ? 0 : 1) + 'M';
  }
  if (value >= 1_000) {
    return (value / 1_000).toFixed(value % 1_000 === 0 ? 0 : 1) + 'K';
  }

  return value.toString();
}
  setIsLoggedIn(value: any) {
    this.isLoggedIn.next(value);
  }
  public get getIsLoggedIn() {
    return this.isLoggedIn.asObservable();
  }
  setCityChanged(value: any) {
    this.cityChanged.next(value);
  }
  public get getCityChanged() {
    return this.cityChanged.asObservable();
  }
  AnyReport(details) {
    return this.http
      .post(domain.anyReport + "PostAnyReport", details)
      .pipe(map((res: any) => res));
  }
  getLogedIn() {

    if (
      this.encryptionService.decryptUsingAES256(
        localStorage.getItem("lg_d_i")
      ) == '"true"'
    ) {
      return true;
    } else {
      return false;
    }
    // return this.encryptionService.decryptUsingAES256(
    //   localStorage.getItem("lg_d_i")
    // ) == "true" ? true
    //   : false;
  }

  getAgentId() {
    let agentId = this.encryptionService.decryptUsingAES256(
      localStorage.getItem("a_n_d")
    );
    return agentId;
  }
  getUserName() {
    let userName = localStorage.getItem("U_Name")
   
    return userName;
  }

  getAgentUserId() {
    let agentUserId = this.encryptionService.decryptUsingAES256(
      localStorage.getItem("ag_u_d")
    );
    return agentUserId;
  }
  getAgentRole() {
    let agentRole = this.encryptionService.decryptUsingAES256(localStorage.getItem("ur_ro_i"));
    return parseInt(agentRole);
  }
  isAgent() {
    let isAgent = this.encryptionService.decryptUsingAES256(localStorage.getItem("i_a_nt")) == '"true"'
    return isAgent;

  }
  agentType() {
    let agentUserType = this.encryptionService.decryptUsingAES256(
      localStorage.getItem("u_ty_i")
    );
    return agentUserType;
  }

  isExpired() {
    let isExpired = this.encryptionService.decryptUsingAES256(
      localStorage.getItem("i_Ex_p")
    );
    if (isExpired == '"true"') {
      return true;
    } else {
      return false;
    }
  }

  private getSelectedCityFromStorage() {
    const encryptedCity = localStorage.getItem("selectedCity");
    if (!encryptedCity) {
      return null;
    }

    try {
      const decryptedCity = this.encryptionService.decryptUsingAES256(encryptedCity);
      if (!decryptedCity || decryptedCity === "undefined" || decryptedCity === "null") {
        return null;
      }

      const firstParse = JSON.parse(decryptedCity);
      const normalizedCity = typeof firstParse === "string" ? JSON.parse(firstParse) : firstParse;

      if (!normalizedCity) {
        return null;
      }

      return {
        id: Number(normalizedCity.id ?? normalizedCity.Id ?? normalizedCity.CityId ?? 0),
        name: String(normalizedCity.name ?? normalizedCity.Name ?? normalizedCity.City ?? "").trim(),
      };
    } catch {
      return null;
    }
  }

  getCityId() {
    const city = this.getSelectedCityFromStorage();
    return city?.id ?? 0;
  }

  getCityName() {
    const city = this.getSelectedCityFromStorage();
    return city?.name ?? "";
  }

  setLogedIn() {
    let token = localStorage.getItem("a_n_d");
    if (token) {
      localStorage.setItem(
        "lg_d_i",
        this.encryptionService.encryptUsingAES256(JSON.stringify(true))
      );
    } else {
      localStorage.setItem(
        "lg_d_i",
        this.encryptionService.encryptUsingAES256(JSON.stringify(false))
      );
    }
    // this.isLoggedIn.next(value);
  }

  isAccountExpired() {
    if (
      this.encryptionService.decryptUsingAES256(
        JSON.parse(localStorage.getItem("isExpired"))
      )
    ) {
      return true;
    } else {
      return false;
    }
  }

  LoginEnterAnimation() {
    let enterAnimation: any = (baseEl: HTMLElement) => {
      const root = baseEl.shadowRoot;

      const backdropAnimation = this.animationCtrl
        .create()
        .addElement(root!.querySelector("ion-backdrop")!)
        .fromTo("opacity", "0.01", "var(--backdrop-opacity)");

      const wrapperAnimation = this.animationCtrl
        .create()
        .addElement(root!.querySelector(".modal-wrapper")!)
        .keyframes([
          { offset: 0, opacity: "0", transform: "scale(0)" },
          { offset: 1, opacity: "0.99", transform: "scale(1)" },
        ]);

      return this.animationCtrl
        .create()
        .addElement(baseEl)
        .easing("ease-out")
        .duration(500)
        .addAnimation([backdropAnimation, wrapperAnimation]);
    };
    return enterAnimation;
  }

  async openUserLoginModal() {
    const modal = await this.modalCtrl.create({
      component: UserLoginPage,
      // breakpoints: [0, 0.6, 1],
      // initialBreakpoint: 0.8,
      backdropDismiss: false,
      cssClass: "login-modal",
      enterAnimation: this.LoginEnterAnimation(),
    });
    await modal.present().then(() => {
      // Do stuff it's open
    });
  }
  async openUserSignUpModal() {
    const modal = await this.modalCtrl.create({
      component: AgentSignupComponent,
      // breakpoints: [0, 0.6, 1],
      // initialBreakpoint: 0.8,
      backdropDismiss: false,
      cssClass: "login-modal",
      enterAnimation: this.LoginEnterAnimation(),
    });
    await modal.present().then(() => {
      // Do stuff it's open
    });
  }

  // amountToText(value: any) {
  //   const toWords = new ToWords({
  //     localeCode: "en-IN",
  //     converterOptions: {
  //       currency: true,
  //       ignoreDecimal: false,
  //       ignoreZeroCurrency: false,
  //       doNotAddOnly: false,
  //       currencyOptions: {
  //         // can be used to override defaults for the selected locale
  //         name: "Rupee",
  //         plural: "Rupees",
  //         symbol: "₹",
  //         fractionalUnit: {
  //           name: "Paisa",
  //           plural: "Paise",
  //           symbol: "₹",
  //         },
  //       },
  //     },
  //   });
  //   return toWords.convert(value);
  // }

  opneInfoDialog(dialogTitle, dialogDesc) {
    this.matDialog.open(DialogInfoDetailsComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: false,
      backdropClass: "mat-dialog-blur-backdrop",
      data: { dialogTitle: dialogTitle, dialogDesc: dialogDesc } // Pass any data if needed
    });
  }
}
